module.exports = __webpack_public_path__ + "img/features-4.18c398b9.jpg";